module.exports = __webpack_public_path__ + "img/Checking.5439e43c.svg";